<template>
  <b-tab title="Laudo Técnico" :active="ativo" class="m-0 p-0">
    <div id="screen-form" class="pl-2 pr-2 mt-2">
      <div id="LaudoTecnicoPrint">
        <b-container fluid>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::: CAPA DO RELATÓRIO ::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <first-page :laudo="laudo" :equipamento="equipamento" />

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::: INFORMAÇÕES GERAIS :::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <second-page :laudo="laudo" :equipamento="equipamento" />

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::: DESCRIÇÃO DO EQUIPAMENTO ::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <third-page :laudo="laudo" :equipamento="equipamento" @callImageSelector="callImageSelector($event)" />

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::: CONDIÇÕES OPERACIONAIS :::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <fourth-page :laudo="laudo" :equipamento="equipamento" />

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::: INSPEÇÃO MECÂNICA ::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <fifth-page v-if="laudo.displayMecanica" :laudo="laudo" :equipamento="equipamento" />

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::: INSPEÇÃO ELÉTRICA ::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <sixth-page v-if="laudo.displayEletrica" :laudo="laudo" :equipamento="equipamento" />

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::: INSPEÇÃO DE MOTORES :::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <seventh-page v-if="laudo.displayMotor" :laudo="laudo" :equipamento="equipamento" />

          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::: RECOMENDAÇÕES E CONCLUSÃO ::::::::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <eighth-page :laudo="laudo" :equipamento="equipamento" />
        </b-container>
      </div>
    </div>

    <!-- :::::::::::::::::::::::::::: MODAIS DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <imagem-list-modal ref="imgListLaudo" @loadImagem="loadImagem($event)" />
    <detalhe-modal ref="detalheLaudoTecnico" />
    <descricao-modal ref="descricaoLaudoTecnico" />
    <condicao-modal ref="condicaoLaudoTecnico" />
    <mecanica-modal ref="mecanicaLaudoTecnico" />
    <eletrica-modal ref="eletricaLaudoTecnico" />
    <motor-modal ref="motorLaudoTecnico" />
    <conclusao-modal ref="conclusaoLaudoTecnico" />
    <!-- :::::::::::::::::::::::::::: COMANDOS DO RELATÓRIO :::::::::::::::::::::::::::: -->
    <div class="menu-acoes p-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <h4 class="exo-1 m-0 mr-2">SGCQ</h4>
            <b-form-input id="sgcq-call" type="number" size="sm" class="m-1 p-1" placeholder="Sgcq" v-model="sgcq" />
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="primary" @click="loadEquipamento()">
              <b-icon icon="box-arrow-in-up-right" variant="light" scale="1.1" class="mr-2" />Buscar
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadDetalhes()">
              <b-icon icon="file-earmark-richtext" variant="light" scale="1.1" class="mr-2" />Detalhes
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadDescricao()">
              <b-icon icon="file-earmark-ruled" variant="light" scale="1.1" class="mr-2" />Descrição
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadCondicao()">
              <b-icon icon="file-earmark-spreadsheet" variant="light" scale="1.1" class="mr-2" />Condição
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadMecanica()">
              <b-icon icon="gear-wide" variant="light" scale="1.1" class="mr-2" />Mecânica
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadEletrica()">
              <b-icon icon="tools" variant="light" scale="1.1" class="mr-2" />Elétrica
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadMotor()">
              <b-icon icon="gear-fill" variant="light" scale="1.1" class="mr-2" />Motor
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadConclusao()">
              <b-icon icon="journal-bookmark-fill" variant="light" scale="1.1" class="mr-2" />Conclusão
            </b-button>
            <b-button size="sm" class="ml-2 pl-2 pr-3" variant="warning" v-print="printLaudo">
              <b-icon icon="printer" variant="light" scale="1.1" class="mr-2" />Imprimir
            </b-button>
          </b-form>
        </b-col>
      </div>
    </div>
  </b-tab>
</template>

<script>
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import { useLaudoTecnicoStore } from "@/stores/LaudoTecnicoStore";
import LaudoTecnico from "@/models_reports/LaudoTecnico";
import Equipamento from "@/models/Equipamento";
import Cliente from "@/models/Cliente";
import Files from "@/http/files";
import FirstPage from "@/components/reports/laudo_tecnico/pages/FirstPage";
import SecondPage from "@/components/reports/laudo_tecnico/pages/SecondPage";
import ThirdPage from "@/components/reports/laudo_tecnico/pages/ThirdPage";
import FourthPage from "@/components/reports/laudo_tecnico/pages/FourthPage";
import FifthPage from "@/components/reports/laudo_tecnico/pages/FifthPage";
import SixthPage from "@/components/reports/laudo_tecnico/pages/SixthPage";
import SeventhPage from "@/components/reports/laudo_tecnico/pages/SeventhPage";
import EighthPage from "@/components/reports/laudo_tecnico/pages/EighthPage";
import ImagemListModal from "@/components/modals/imagem/ImagemListModal";
import LaudoTecnicoDetalhe from "@/components/reports/laudo_tecnico/modals/LaudoTecnicoDetalhe";
import LaudoTecnicoDescricao from "@/components/reports/laudo_tecnico/modals/LaudoTecnicoDescricao";
import LaudoTecnicoCondicao from "@/components/reports/laudo_tecnico/modals/LaudoTecnicoCondicao";
import LaudoTecnicoMecanica from "@/components/reports/laudo_tecnico/modals/LaudoTecnicoMecanica";
import LaudoTecnicoEletrica from "@/components/reports/laudo_tecnico/modals/LaudoTecnicoEletrica";
import LaudoTecnicoMotor from "@/components/reports/laudo_tecnico/modals/LaudoTecnicoMotor";
import LaudoTecnicoConclusao from "@/components/reports/laudo_tecnico/modals/LaudoTecnicoConclusao";

export default {
  name: "LaudoTecnicoReport",

  components: {
    "first-page": FirstPage,
    "second-page": SecondPage,
    "third-page": ThirdPage,
    "fourth-page": FourthPage,
    "fifth-page": FifthPage,
    "sixth-page": SixthPage,
    "seventh-page": SeventhPage,
    "eighth-page": EighthPage,
    "imagem-list-modal": ImagemListModal,
    "detalhe-modal": LaudoTecnicoDetalhe,
    "descricao-modal": LaudoTecnicoDescricao,
    "condicao-modal": LaudoTecnicoCondicao,
    "mecanica-modal": LaudoTecnicoMecanica,
    "eletrica-modal": LaudoTecnicoEletrica,
    "motor-modal": LaudoTecnicoMotor,
    "conclusao-modal": LaudoTecnicoConclusao,
  },

  data() {
    return {
      sgcq: 0,
      ativo: false,
      laudo: new LaudoTecnico(),
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(0, "Novo Equipamento", "", "", "", "", "", "", "", "", ""),
      files: new Files(this.$http),
      printLaudo: {
        id: "LaudoTecnicoPrint",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
    };
  },

  methods: {
    loadEquipamento() {
      if (this.sgcq != 0 && this.sgcq != "") {
        this.equipamento.update(this.getBySgcq(this.sgcq)[0]);
        this.cliente.update(this.equipamento.cliente);
        this.equipamentoStore.LISTAR_SERVICOS(this.equipamento.sgcq).then(() => {
          this.laudo.servicos = this.getServicos;
          let servicoData = new Date(this.getLastServico[0].data);
          this.laudo.data = new Date(this.getLastServico[0].data);
          let ano = servicoData.getFullYear();
          this.laudo.numero = "RN" + this.getLastServico[0].id + "-" + this.sgcq + "-" + ano + "-LTEC";
          this.identificacao = this.equipamento.sgcq;
          if (this.equipamento.codigo != "" && this.equipamento.codigo != "- - -") {
            this.identificacao = this.equipamento.sgcq + " - " + this.equipamento.codigo;
          }

          //carrega a imagem do equipamento
          this.files.downloadEquipamento(this.equipamento.sgcq).then((response) => {
            const reader = new FileReader();
            const blob = new Blob([response]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.laudo.imgFirstPage = e.target.result;
            };
          });
        });
      }
    },

    loadDetalhes() {
      this.$refs.detalheLaudoTecnico.call(this.laudo);
    },

    loadDescricao() {
      this.$refs.descricaoLaudoTecnico.call(this.laudo);
    },

    loadCondicao() {
      this.$refs.condicaoLaudoTecnico.call(this.laudo);
    },

    loadMecanica() {
      this.$refs.mecanicaLaudoTecnico.call(this.laudo);
    },

    loadEletrica() {
      this.$refs.eletricaLaudoTecnico.call(this.laudo);
    },

    loadMotor() {
      this.$refs.motorLaudoTecnico.call(this.laudo);
    },

    loadConclusao() {
      this.$refs.conclusaoLaudoTecnico.call(this.laudo);
    },

    callImageSelector() {
      this.$refs.imgListLaudo.call();
    },

    loadImagem(imagem) {
      this.laudo.imgThirdPage = imagem;
    },
  },

  setup() {
    const equipamentoStore = useEquipamentoStore();
    const laudoTecnicoStore = useLaudoTecnicoStore();

    //Getters from stores
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const { getServicos } = storeToRefs(equipamentoStore);
    const { getLastServico } = storeToRefs(equipamentoStore);
    const { getSelected } = storeToRefs(laudoTecnicoStore);

    return {
      equipamentoStore,
      getBySgcq,
      getServicos,
      getLastServico,
      getSelected,
    };
  },
};
</script>

<style lang="scss" scoped>
#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

#sgcq-call {
  width: 6rem;
}

.menu-acoes {
  background-color: #112a4a;
}

.exo-1 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-size: 1.4rem;
  padding: 0;
  color: white;
}
</style>
